<nb-card>
    <nb-card-header>{{ title }}</nb-card-header>
    <nb-card-body>
        <div [innerHtml]="message"></div>
    </nb-card-body>
    <nb-card-footer>
        <button class="cancel mr-3" nbButton status="danger" (click)="cancel()">Cancel</button>
        <button nbButton status="success" (click)="ok()">Ok</button>
    </nb-card-footer>
</nb-card>
      